import { render, staticRenderFns } from "./FrameSpecification.vue?vue&type=template&id=081644cc&lang=pug"
import script from "./FrameSpecification.vue?vue&type=script&setup=true&lang=ts"
export * from "./FrameSpecification.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports